import { createFileRoute } from "@tanstack/react-router";
import { legacyRedirect } from "@/lib/legacy-redirect";

export const Route = createFileRoute("/feed/")({
  beforeLoad: () => legacyRedirect("/blog"),
});
